<template lang='pug'>
  v-tooltip(bottom)
    template(v-slot:activator='{on}')
      font-awesome-icon(v-on='on' icon='file-export').ml-1
    div This module uses explicit exports:
    pre module.exports = {};
</template>

<script>
export default {
  name: 'ExplicitExports'
};
</script>

<style scoped>
</style>
